import React from "react";
import * as Yup from 'yup';
import { AccountData, UserDataDto } from "../../generated"
import { Forms } from "../../common/components/CmForms";
import { requiresUser } from "../loginHelpers";
const { Form, FormText, FormCheck, ActionBar } = Forms<UserDataDto>()


interface Props {
    operatore: UserDataDto;
    user: AccountData
    onSubmit: (customer: UserDataDto) => void;
    onCancel: () => void;
}

const cmp = class OperatoreForm extends React.Component<Props> {

    private static validationSchemaEdit = Yup.object<Partial<UserDataDto>>({
        nomeOperatore: Yup
            .string()
            .required('Campo obbligatorio'),
    })

    render() {
        const { operatore } = this.props;
        if (!operatore)
            return null;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={operatore}
                validationSchema={OperatoreForm.validationSchemaEdit}
            >
                <>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <FormText
                                name="nomeOperatore"
                                label="Nome Operatore"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                name="username"
                                label="Email"
                                type="email"
                                readOnly
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormCheck
                                name="amministratore"
                                label="Amministratore"
                                disabled={!this.props.user.amministratore}
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormCheck
                                name="disabilitato"
                                label="Disabilitato"
                                disabled={!this.props.user.amministratore}
                            />
                        </div>
                    </div>
                    <ActionBar
                        onCancel={this.props.onCancel}
                    />
                </>
            </Form>
        );
    }
}


export default requiresUser(cmp);